import {
  GET_CAREERS,
  GET_CAREERS_SUCCESS,
  GET_CAREERS_FAILURE,
} from "@store/careers/constants";

import { makeApiCall } from "@lib/api/helpers";

import { getCareersApi } from "@lib/api";

export const getCareers = () => (dispatch, getState) =>
  makeApiCall({
    actions: {
      action: GET_CAREERS,
      success: GET_CAREERS_SUCCESS,
      fail: GET_CAREERS_FAILURE,
    },
    dispatch,
    getState,
    spinner: false,
    alert: false,
    alertMessage: `Nu am putut lua pozitiile disponibile..`,
    apiCall: getCareersApi,
    apiArgs: [],
    formatResponse: (response) => response.data,
    returnResponse: true,
  });
